<template>
  <div class="prviewXlsx">
    <div v-html="tableau"></div>
  </div>
</template>

<script>
import axios from 'axios'
import XLSX from "xlsx";

export default {
  props: {
    url: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      tableau: ''
    }
  },
  watch: {
    url: {
      handler(val) {
        axios({
          method: 'get',
          responseType: 'arraybuffer', // 设置响应文件格式
          url: 'https://obs-992b.obs.cn-north-4.myhuaweicloud.com:443/WMS%2FDEV%2Flightning_1669013420274.png',
        }).then(({data}) => {
          let workbook = XLSX.read(new Uint8Array(data), {type: "array"}); // 解析数据
          var worksheet = workbook.Sheets[workbook.SheetNames[0]]; // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
          this.tableau = XLSX.utils.sheet_to_html(worksheet); // 渲染
        })
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
